module.exports = __webpack_public_path__ + "static/media/6.9fcde481.gif";